var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZero = function SvgZero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31 15.995C8.31 9.297 11.039 5.08 16 5.08s7.69 4.217 7.69 10.915c0 6.698-2.729 10.915-7.69 10.915-5.209.248-7.69-3.969-7.69-10.915zm11.659 0c0-4.713-1.24-7.69-3.969-7.69s-3.969 3.225-3.969 7.69 1.24 7.69 3.969 7.69c2.481.248 3.969-2.977 3.969-7.69z"
  })));
};
export default SvgZero;